module.exports = __webpack_public_path__ + "static/media/juntos.2aebb5ce.mp3";